"use strict";

const ENTER_KEY = 13;
const SPACE_KEY = 32;
var focusevents = require("./focusevents");

/**
* @description Initializes simpler toggler functionality based on class names and css component
*/

var toggler = function () {
    /**
     * @function
     * @description - initializes each instance of the toggler found, based on the param passed
     */

    $("body").on("click keydown", ".c-toggler .c-toggler__title, .c-toggler .c-toggler__button", function (e) {
        var $this = $(this);

        if (e.type === "click" || e.type === "keydown" && (e.keyCode === ENTER_KEY || e.keyCode === SPACE_KEY)) {
            e.preventDefault();
            var $togglerContainer = $this.closest(".c-toggler");

            if ($togglerContainer.hasClass("c-toggler--expanded")) {
                focusevents.destroyFocusTrap($togglerContainer);
            } else {
                focusevents.initFocusTrap($togglerContainer);
            }

            if ($(".c-toggler--all-expanded").length) {
                $togglerContainer.toggleClass("c-toggler--expanded");
            } else {
                $togglerContainer.toggleClass("c-toggler--expanded").siblings().removeClass("c-toggler--expanded");
            }

            $this.attr("aria-expanded", $this.attr("aria-expanded") === "true" ? false : true);
            $togglerContainer.siblings().find(".c-toggler__title").attr("aria-expanded", false);
        }
    });

    $("body").on("click keydown", ".c-toggler--accordion .c-toggler__title", function (e) {
        var $this = $(this);
        var $accordionBlock = $(".c-toggler--accordion");

        if (e.type === "click" || e.type === "keydown" && (e.keyCode === ENTER_KEY || e.keyCode === SPACE_KEY)) {
            e.preventDefault();
            var $togglerContainer = $this.closest(".c-toggler--accordion");

            if ($togglerContainer.hasClass("c-toggler--expanded")) {
                focusevents.destroyFocusTrap($togglerContainer);
            } else {
                focusevents.initFocusTrap($togglerContainer);
            }

            if ($accordionBlock.length) {
                $accordionBlock.find(".c-toggler__title").attr("aria-expanded", "false");
                $accordionBlock.removeClass("c-toggler--expanded");
                $(document).trigger("toggler.open");
            }

            $togglerContainer.toggleClass("c-toggler--expanded").siblings().removeClass("c-toggler--expanded");
            $this.attr("aria-expanded", $this.attr("aria-expanded") === "true" ? false : true);
        }
    });
};

module.exports = toggler;
